var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_521_10694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2799 2.08325L17.9166 6.72242V13.2808L13.2799 17.9166H6.72159L2.08325 13.2799V6.72159L6.72159 2.08325H13.2799ZM12.5891 3.74992H7.41159L3.75075 7.41242V12.5899L7.41159 16.2516H12.5891L16.2508 12.5899V7.41159L12.5891 3.74992ZM6.66658 9.16658H13.3333V10.8333H6.66658V9.16658Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 9.16658H6.66658V10.8333H13.3333V9.16658Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 6.66658V13.3333H10.8332V6.66658H9.1665Z",
    fill: "#898989"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_521_10694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/activate.580e45dfa782a02c8f24a3c3f7b0a7c6.svg";
export { ForwardRef as ReactComponent };